import { type ApolloLink } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { Kind, OperationTypeNode } from 'graphql/language'

import {
  RETRYABLE_STATUS_CODES,
  RETRY_INITIAL_DELAY_MS,
  RETRY_MAX_ATTEMPTS,
  RETRY_MAX_DELAY_MS,
} from './retryLink.consts'

export const shouldRetryOnStatusCode = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') {
    return false
  }

  if (!('statusCode' in error) || typeof error.statusCode !== 'number') {
    return false
  }

  return RETRYABLE_STATUS_CODES.includes(error.statusCode)
}

const isMutation = (operation: ApolloLink.Operation): boolean => {
  const definition = operation.query.definitions.find(
    (definition): definition is typeof definition & { kind: Kind.OPERATION_DEFINITION } =>
      definition.kind === Kind.OPERATION_DEFINITION,
  )

  return definition?.operation === OperationTypeNode.MUTATION
}

export const shouldRetry = (error: unknown, operation: ApolloLink.Operation): boolean => {
  if (isMutation(operation)) {
    return false
  }

  return shouldRetryOnStatusCode(error)
}

export const retryLink = new RetryLink({
  attempts: {
    max: RETRY_MAX_ATTEMPTS,
    retryIf: shouldRetry,
  },
  delay: {
    initial: RETRY_INITIAL_DELAY_MS,
    max: RETRY_MAX_DELAY_MS,
    jitter: true,
  },
})
